<template>
    <div>
        <redeem-button
            :isLogin="isLogin"
            :point="availablePoint"
            :selectedPoint="selectedPoint"
            :selectedQuantity="selectedQuantity"
            :lblRedeemBTN="lbl.redeem_button"
            :campaign="campaign"
            :redeemBTN="redeemBTN"
            v-if="isForceRender && checkLoadingLogin && isLogin"
            @clickRedeem="clickRedeem()">
        </redeem-button>

        <modal view="redeem-component"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>
        <confirm-redeem-modal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmRedeem"
            @clickConfirmRedeem="clickConfirmRedeem()"></confirm-redeem-modal>
        <serial-modal
            :lbl="lbl"
            :busSerialModal="busSerialModal"
            @closeSerialModal="clickCloseSerialModal()"></serial-modal>
        <shipping-address-list-modal
            :lblShipping="lbl.shipping"
            :busShippingListModal="busShippingListModal"
            @clickAddAddress="clickAddAddress($event)"
            @onEditAddress="onEditAddress($event)"
            @onDeleteAddress="onDeleteAddress($event)"
            @onSelectAddress="selectAddress($event)"></shipping-address-list-modal>
        <shipping-address-modal
            :lblShipping="lbl.shipping"
            :addressModel="addressModel"
            :formAddress="formAddressModel"
            :errorInfo="shippingAddressValidateInfo"
            :busShippingModal="busShippingModal"
            :type="addressType"
            @clickConfirmAddress="clickConfirmAddress($event)"
            @clickUpdateAddress="onUpdateAddress()"></shipping-address-modal>
        <confirm-address-modal
            :lbl="lbl"
            :type="addressType"
            :address="addressModel"
            :campaign="campaign"
            :busAddressSuccessModal="busAddressSuccessModal"
            @onConfirmDeleteAddress="confirmDeleteAddress()"
            @onReEditAddress="onEditAddress()"
            @onConfirmToRedeem="confirmEditAddress()"></confirm-address-modal>
        <ConsentSurveyModal
            :lbl="lbl"
            :busModal="busConsentSurveyModal"
            @clickNext="submitConsent($event)"
        ></ConsentSurveyModal>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import Util from "@/helper/Utility.js";
import Account from '@/helper/AccountHelper.js';
import RedeemButton from '@/components/campaign/detail/RedeemButton.vue';
import Locale from '@/helper/locale/locale.js';
//Service
import BzbsCampaign from '@/service/BzbsCampaign.js';
import {
    CampaignConfigBuilder,
    RedeemConfigBuilder,
    //RedeemShippingAdressBuilder
} from '@/service/config/CampaignConfigModel.js';
import ThlPDPA from "@/service/ThlPDPA.js";
import { AddressModel } from "@/service/config/AddressModel"
import { AddressListModel } from "@/service/config/AddressListModel"
import BzbsAddressList from "@/service/BzbsAddressList";
//Modal
import Modal from '@/components/modal/Modal.vue';
import ConfirmRedeemModal from '@/components/modal/ConfirmRedeemModal.vue';
import SerialModal from '@/components/modal/SerialModal.vue';
import ShippingAddressModal from '@/components/modal/ShippingAddressModal.vue';
import ConsentSurveyModal from '@/components/modal/ConsentSurveyModal.vue';
import ShippingAddressListModal from '@/components/modal/ShippingAddressListModal.vue';
import ConfirmAddressModal from "@/components/modal/ConfirmAddressModal.vue";
/**
 * Property
 * @property {object} lbl Text for Component.
 * @property {object} campaign Campaign model.
 * @property {number} selectedId Selected campaign for redeem in case of campaign contain sub-campaign.
 * @property {number} selectedQuantity Selected campaign quantity.
 * @property {number} selectedPoint Selected campaign use/get point.
 * Event
 * @event clickRedeem Click validate redeem.
 * @event clickConfirmRedeem Click confirm to proceed redeem define type of campaign.
 * Method
 * @method checkRedeemCondition Check if user can or cannot redeem.
 * @method openWebsite Redirect by campaign condition to website after redeem.
 * @method openSurvey Redirect by campaign condition to website after redeem.
 * @method callInterfaceApi Call api by campaign condition after redeem.
 * @method initialShippingAddress Setup data model and open shipping address modal.
 * @method clickConfirmAddress Validate shipping address and proceed redeem.
 * @method redeem Call redeem api for redeem.
 * @method updateCampaign Call Campaign detail api to update data.
 * @method updateCampaignInfo Emit parent method to update data.
 * @method initialSerialModal Open Serial modal.
 * Utilities
 * @method forceRender Force component to rerender.
 */
export default {
    name: "Redeem",
    components: {
        RedeemButton,
        Modal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        ConsentSurveyModal,
        ShippingAddressListModal,
        ConfirmAddressModal,
    },
    props: {
        lbl: Object,
        campaign: Object,
        selectedId: Number,
        selectedQuantity: Number,
        selectedPoint: Number
    },
    data: function() {
        return {
            checkLoadingLogin: false,
            isLogin: false,
            user: {},
            availablePoint: 0,
            redeemBTN: {
                strRedeemLabel: '',
                isAllowRedeem: true,
                isButtonDisable: false,
                strDisableClass: 'redeem-disable',
                isUseDefault: false
            },
            redeemConfig: null,
            redeemShippingAdress: null,
            redeemInfoConfig: null,
            redeemLocation: null,
            redeemOtherConfig: null,
            campaignConfig: null,

            serialCampaign: {},
            isForceRender: true,

            shippingAddressValidateInfo: {
               isValid: true,
               msg: ''
            },

            addressType: 'add',

            objConsent: {
                "consentStatus": false,
                "consentMessage": "ไม่พบข้อความ",
                "consentDate": ""
            },

            formAddressModel: new AddressModel(),
            addressModel: new AddressListModel(),

            busModal: new Vue(),
            busConfirmRedeem: new Vue(),
            busSerialModal: new Vue(),
            busShippingModal: new Vue(),
            busConsentSurveyModal: new Vue(),
            busShippingListModal: new Vue(),
            busAddressSuccessModal: new Vue(),
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            if (status)
                this.user = Account.getCacheUser();

            this.checkLoadingLogin = true;
        });
        this.availablePoint = Account.getCachePoint();
        this.redeemConfig = new RedeemConfigBuilder().create();
    },
    methods: {
        //Event
        clickRedeem: function () {
            //GA
            var label = this.campaign.id + "|" + this.campaign.name;
            var gtm = {
                 "event_label": this.campaign.name,
                 "privilege_category_name": this.campaign.categoryName,
                 "privilege_id": this.campaign.id,
                 "timestamp": moment().format("YYYYMMDD HH:mm:ss")
            };
            Vue.ga.event(this, "privilege", "click_redeem", label, null, gtm);

            if(!this.redeemBTN.isAllowRedeem) return;
            if(!this.isLogin) return;

            var strRedeemCondition = this.checkRedeemCondition();
            if (strRedeemCondition == "open_web_survey")
            {
                this.enquiryConsent();
            } else {
                this.busConfirmRedeem.$emit('showConfirmRedeemModal', {});
            }
        },
        clickConfirmRedeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;
            var label = this.campaign.id + "|" + this.campaign.name;
            Vue.ga.event(this, "privilege_click_redeem", "click_campaign", label);

            var strRedeemCondition = this.checkRedeemCondition();
            switch(strRedeemCondition) {
                case 'open_web':
                    this.openWebsite();
                    break;
                case 'open_web_survey':
                    this.enquiryConsent();

                    break;
                case 'call_api':
                    this.callInterfaceApi();
                    //No longer see this being use.
                    break;
                case "update_shipping_address":
                    this.initialShippingAddressList();
                    break;
                default:
                    this.redeem();
                    break;
            }
        },
        //Function
        checkRedeemCondition: function () {
            var strResult = 'redeem';
            switch(this.campaign.type) {
                case Vue.CampaignType.Buy:
                    strResult = 'open_web';
                    break;
                case Vue.CampaignType.Interface:
                    if(!this.campaign.interfaceDisplay) return;

                    if(this.campaign.interfaceDisplay === 'web') strResult = 'open_web';
                    if(this.campaign.interfaceDisplay === 'survey' || this.campaign.interfaceDisplay === 'surveyapprove') strResult = 'open_web_survey'
                    if(this.campaign.interfaceDisplay === 'api') strResult = 'call_api';
                    break;
                default:
                    if(this.campaign.delivered) strResult = 'update_shipping_address';
                    break;
            }

            return strResult;
        },
        openWebsite: function () {
            if(!this.campaign.website) return;

            var webUrl = this.campaign.website;
            var localeCode = Locale.getLocaleCode();
            var isShowHeader = 'false';
            var theme = Vue.bzbsConfig.appname;
            var suffledToken = Util.shuffleToken(Account.getToken());
            var returnUrl = encodeURIComponent(window.location.href);
            var isLanding = '%3Flanding%3DTrue';
            if (returnUrl.indexOf(isLanding) < 0) {
                returnUrl += isLanding;
            }

            if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0 ||
                webUrl.indexOf('/Landing/Ais') >= 0 ||
                webUrl.indexOf('/Landing/dtac') >= 0 ||
                webUrl.indexOf('starbucks') >= 0 ) {
                Account.setCacheCustom('isfromlanding', { page: 'interface' });
            } else if (webUrl.indexOf('wondd') >= 0) {
                Account.setCacheCustom('isfromlanding', { page: 'wodd' });
            } else {
                Account.setCacheCustom('isfromlanding', { page: 'other' });
            }

            webUrl += '&token=' + suffledToken
                    + '&locale=' + localeCode
                    + '&header=' + isShowHeader
                    + '&theme=' + theme
                    + '&return_url=' + returnUrl;

            // support history truemoney
            if (webUrl.indexOf('wondd/truemoney') == -1 && webUrl.indexOf('truemoney') >= 0) {
                webUrl += '&history_url=' + encodeURIComponent(window.location.origin + '/history')+isLanding;
            }

            window.location.href = webUrl;

            // var bzbsToken = Account.getToken();
            // var localeCode = Locale.getLocaleCode();
            // var returnUrl = encodeURIComponent(window.location.href);
            // switch(this.campaign.type) {
            //     case Vue.CampaignType.Buy:
            //         var strUrl = '';
            //         var strLocale = '';
            //         var strEncryptToken = Util.shuffleToken(bzbsToken);
            //         switch(localeCode) {
            //             case 1033:
            //                 strLocale = 'E';
            //                 break;
            //             case 1054:
            //                 strLocale = 'T';
            //                 break;
            //         }

            //         if(this.campaign.website.indexOf('.buzzebees.com/payment/')) {
            //             var arrSplittedUrl = this.campaign.website.split('/payment');
            //             strUrl = Vue.bzbsConfig.bzbShoppingCartUrl + '/payment' + arrSplittedUrl[1] + '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
            //         } else {
            //             strUrl = this.campaign.website = '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
            //         }

            //         window.location = strUrl;
            //         break;
            //     case Vue.CampaignType.Interface:
            //         var isShowHeader = 'false' //show/hide header.
            //         var strTheme = '';
            //         var isLanding = '%3Flanding%3DTrue';
            //         if (returnUrl.indexOf(isLanding) < 0) {
            //             returnUrl += isLanding;
            //         }
            //         window.location.href = this.campaign.website + '&token=' + bzbsToken + '&locale=' + localeCode + '&header=' + isShowHeader + '&theme=' + strTheme + '&return_url=' + returnUrl; // ReturnUrl;
            //         break;
            // }
        },
        openSurvey: function () {
            var webUrl = this.campaign.website;
            var isShowHeader = 'true';
            var theme = 'thailife'
            var suffledToken = Account.getShuffleToken();
            var returnUrl = encodeURIComponent(window.location.href);
            var success = encodeURIComponent(window.location.origin + "/history");
            var isLanding = '%3Flanding%3DTrue';
            var isPopup = Account.isPopup();

            if (success.indexOf(isLanding) < 0) {
                success += isLanding;
            }


            if (returnUrl.indexOf(isLanding) < 0) {
                if (isPopup == "true") {
                    returnUrl = encodeURIComponent(window.location.href + "?landing=True&popup=true");
                    success = encodeURIComponent(window.location.href + "?landing=True&popup=true");
                } else {
                    returnUrl = encodeURIComponent(window.location.href + "?landing=True");
                }
            } else {
                if (isPopup == "true") {
                    returnUrl = encodeURIComponent(window.location.href + "?popup=true");
                    success = encodeURIComponent(window.location.href + "?popup=true");
                }
            }



            webUrl += '&token=' + suffledToken
                    + '&locale=' + Locale.getLocaleCode()
                    + '&header=' + isShowHeader
                    + '&theme=' + theme
                    + '&return_url=' + returnUrl
                    + '&success_survey_url=' + success;

            window.location.href = webUrl;
        },
        callInterfaceApi: function () {

        },
        submitConsent: function (objSubmint) {
            if (objSubmint.isCheck) {
                var bzbsToken = Account.getToken();
                var objdata = {
                    date: this.objConsent.consentDate
                };
                ThlPDPA.apiPostConsentSurvey(bzbsToken,objdata)
                .then(result => {
                    console.log(result);
                    this.openSurvey();
                })
                .catch(error => {
                    console.log(error);
                });
            }
        },
        enquiryConsent: function() {
            var bzbsToken = Account.getToken();
            ThlPDPA.apiGetConsentSurvey(bzbsToken)
            .then(result => {
                if (result.data && result.data.surveyStatus) {
                    this.objConsent.consentStatus = result.data.surveyStatus;
                }

                if (result.data.surveyMessage) {
                    this.objConsent.consentMessage = result.data.surveyMessage;
                }

                if (result.data.surveyDate) {
                    this.objConsent.consentDate = result.data.surveyDate;
                }

                if (this.objConsent.consentStatus == false) {
                    this.busConsentSurveyModal.$emit('showConsentSurvayModal', this.objConsent);
                } else {
                    this.openSurvey();
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        //Shipping
        initialShippingAddressList: function () {
            this.busShippingListModal.$emit('showShippingAddressListModal', {});
        },
        clickAddAddress: function (address) {
            this.initialShippingAddress(address);
        },
        initialShippingAddress: function (address) {
            if (address) {
                this.addressType = 'edit'
                this.formAddressModel.setAddressFromAddressListItem(address)
                this.addressModel = address
            } else {
                this.addressType = 'add'
                this.formAddress = new AddressModel()
                this.addressModel = new AddressListModel()
            }
            this.busShippingModal.$emit('showShippingAddressModal', {});
        },
        clickConfirmAddress: function () {
            this.addressModel.setValueFromAddressModel(this.formAddressModel);
            if(!this.shippingAddressValidateInfo.isValid) {
                this.showAlertModal(this.lbl.shipping.alert_headline,
                                    this.shippingAddressValidateInfo.msg,
                                    this.lbl.shipping.alert_ok_btn,
                                    "shipping");
            
            } else {
                this.addAddress(this.addressModel)
            }
        },
        onDeleteAddress: function (address) {
            this.showConfirmAddressPopup('delete',address)
        },
        onEditAddress: function (address) {
            this.addressType = 'edit'
            if (address) {
                this.initialShippingAddress(address);
            } else {
                this.initialShippingAddress(this.addressModel);
            }
        },
        onUpdateAddress: function () {
            this.showConfirmAddressPopup('edit', this.addressModel)
        },
        //add address
        addAddress: function(addressModel) {
            if (addressModel != null) {
                let token = Account.getToken();
                let params = addressModel.getParams();

                BzbsAddressList.apiAddAddress(token, params)
                    .then(data => {
                        let address = new AddressListModel();
                        address.setValueFormApi(data);
                        this.addressModel = address
                        this.confirmRedeemAddress()
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        //update address
        updateAddress: function(address) {
            var token = Account.getToken();
            BzbsAddressList.apiUpdateAddress(token, address)
                .then(res => {
                    this.addressModel.setValueFormApi(res.data)
                    this.confirmRedeemAddress()
                })
                .catch(error => {
                    console.log(error);
                });
        },
        //delete address
        deleteAddress: function(address) {
            var token = Account.getToken();
            BzbsAddressList.apiDeleteAddress(token, address.rowKey)
                .then(res => {
                    console.log(res)
                    this.initialShippingAddressList()
                })
                .catch(error => {
                    console.log(error);
                });
        },
        //selectAddress
        selectAddress: function (address) {
            this.addressModel = address
            this.confirmRedeemAddress();
        },
        //address success modal
        showConfirmAddressPopup: function(type,address) {
            this.addressModel = address
            this.addressType = type
            // console.log('addressModel : ',this.addressModel)
            this.busAddressSuccessModal.$emit('showConfirmAddressModal', {});
        },
        confirmDeleteAddress: function () {
            this.deleteAddress(this.addressModel)
        },
        confirmEditAddress: function() {
            this.addressModel.setValueFromAddressModel(this.formAddressModel);
            this.updateAddress(this.addressModel.getParams());
        },
        confirmRedeemAddress: function () {
            this.redeemShippingAdress = { addressKey: this.addressModel.rowKey, contactNumber: this.addressModel.contactNumber};
            this.redeem();
        },
        //Redeem
        redeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;

            var bzbsToken = Account.getToken();
            let catInfo = "Normal";

            const normalizedCategoryName = (this.campaign.categoryName || "")
                .toLowerCase()
                .replace(/\s+/g, "")
                .trim();

            if (normalizedCategoryName === "lifeverse") {
                catInfo = "LifeVerse";
            } else if (normalizedCategoryName === "lifeversefamily") {
                catInfo = "LifeVerseFamily";
            }

            this.objRedeemInfoConfig = {
                info4: this.user.userLevel,
                info5: catInfo,
            };

            BzbsCampaign.apiRedeemCampaign(bzbsToken, this.selectedId, this.redeemConfig, this.redeemShippingAdress, this.objRedeemInfoConfig, null, null)
                .then((campaign) => {
                    this.campaign.updateAfterRedeem(campaign);

                    //GA
                    var label = this.campaign.id + "|" + this.campaign.name;
                    var gtm = {
                        "event_label": this.campaign.name,
                        "privilege_category_name": this.campaign.categoryName,
                        "privilege_id": this.campaign.id,
                        "transaction_id": this.serial,
                        "timestamp": moment().format("YYYYMMDD HH:mm:ss")
                    };
                    Vue.ga.event(this, "privilege", "start_redeem_step1", label, null, gtm);

                    this.initialSerialModal();
                }).catch((error) => {
                    console.log(error.response);
                    // this.showAlertModal(this.lbl.shipping.alert_headline,
                    //                 error.response.data.message,
                    //                 this.lbl.shipping.alert_ok_btn,
                    //                 "redeem");
                });
        },
        updateCampaign: function () {
            var strBzbsToken = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                    .setCampaignId(this.campaign.id)
                    .create();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((data) => {
                this.campaign.updateCampaign(data);
                this.updateCampaignInfo(data);
                this.forceRender();
            }).catch((error) => {
                console.log(error);
            });
        },
        updateCampaignInfo: function (campaign) {
            this.$emit('updateCampaignInfo', campaign);
        },
        initialSerialModal: function () {
            if (this.campaign.delivered === true) {
                this.showConfirmAddressPopup('success',this.addressModel)
            } else {
                this.serialCampaign = this.campaign;
                this.busSerialModal.$emit('showSerialModal', this.serialCampaign);
            }
        },
        clickCloseSerialModal: function () {
            setTimeout(() => {
                this.updateCampaign();
            }, 1000);
        },
        //Utilities
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        // --- modal event ----
        modalConfirmOk: function(event) {
            if (event.tag == 'modal-redeem') {
                this.clickConfirmRedeem();
            }
        },

        showConfirmModal: function(title, message, btnOk, btnCancel, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                strBtnCancel: btnCancel,
                tag: tag,
            };
            this.busModal.$emit('showConfirmModal', configModal);
        },
        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
            switch(e.tag) {
                case 'shipping':
                    this.busShippingListModal.$emit('showShippingAddressModal', {});
                    break;
            }
        },
        getCampaignTypeTxt: function () {
            var CampaignTypeTxt = ["Draw",
            "Free",
            "Deal",
            "Buy",
            "Bid",
            "Ads",
            "Install",
            "Booking",
            "Interface",
            "Event",
            "Media",
            "EWalletTopup",
            "EWalletRedeem",
            "EWalletTranfer",
            "EWalletBanking",
            "AutoFeed",
            "News",
            "Reservation",
            "EWalletBuy",
            "PointRedemtion",
            "Donate",
            "PointFree",
            "Voucher"];

            return CampaignTypeTxt[this.campaign.type];
        }
    } // end methods
};
</script>
